import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { setSelectedItemForTable } from '../../store/autoform/autoformSlice';
import Level1Autoform from './Level1Autoform';
import Level2Autoform from './Level2Autoform';
import Level3Autoform from './Level3Autoform';
import Level4Autoform from './Level4Autoform';
import useAutoformMetadata from './hooks/useAutoformMetadata';
import DefinitionsSkeleton from '../utils/DefinitionsSkeleton';
import useAutoformTableMetadata from './hooks/useAutoformTableMetadata';
import AutoformUiProvider from './AutoformUiProvider';

const Autoform = ({ onNodeRename, onNodeItemDelete, itemId, portfolioItem, onNodeOwnershipPercentageUpdate }) => {
    const dispatch = useDispatch();
    const { metadata, hierarchicalTables } = useAutoformMetadata();

    let {
        params: { itemId: routeId },
    } = useRouteMatch();
    const selectedItemId = parseInt(routeId) || itemId;
    const level1TableId = hierarchicalTables.level1[0]?.id;
    const { selectedItem } = useAutoformTableMetadata(level1TableId);
    useEffect(() => {
        if (metadata.maxTableHierarchyLevel > 1 && selectedItemId && level1TableId) {
            dispatch(setSelectedItemForTable({ itemId: selectedItemId, tableId: level1TableId }));
        }
    }, [dispatch, metadata.maxTableHierarchyLevel, selectedItemId, level1TableId]);

    if (!metadata || selectedItem !== selectedItemId) return <DefinitionsSkeleton />;

    return (
        <AutoformUiProvider>
            {metadata.maxTableHierarchyLevel === 1 && <Level1Autoform metadata={metadata} />}
            {metadata.maxTableHierarchyLevel === 2 && (
                <Level2Autoform
                    itemId={selectedItemId}
                    tableId={level1TableId}
                    metadata={metadata}
                    portfolioItem={portfolioItem}
                    onNodeRename={onNodeRename}
                    onNodeItemDelete={onNodeItemDelete}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                />
            )}
            {metadata.maxTableHierarchyLevel === 3 && (
                <Level3Autoform
                    itemId={selectedItemId}
                    tableId={level1TableId}
                    metadata={metadata}
                    portfolioItem={portfolioItem}
                    onNodeRename={onNodeRename}
                    onNodeItemDelete={onNodeItemDelete}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                />
            )}
            {metadata.maxTableHierarchyLevel === 4 && (
                <Level4Autoform
                    itemId={selectedItemId}
                    tableId={level1TableId}
                    metadata={metadata}
                    portfolioItem={portfolioItem}
                    onNodeRename={onNodeRename}
                    onNodeItemDelete={onNodeItemDelete}
                    onNodeOwnershipPercentageUpdate={onNodeOwnershipPercentageUpdate}
                />
            )}
        </AutoformUiProvider>
    );
};

export default Autoform;
